export const RETURN_TO_ACTIVE_PATH_SEGMENTS = ['/quotes', '/checkout'];
export const RETURN_TO_PARAM_NAME = 'returnTo';
export const RETURN_TO_WEBAPP_PARAM_NAME = 'redirect';
